import React from 'react';
import PropTypes from 'prop-types';

const Radio = (props) => {
  const handleOnChange = () => {
    const { onChange, isChecked } = props;
    onChange(!isChecked);
  };

  const { isChecked, className, errormessage, label, id, ...rest } = props;

  return (
    <label className={className}>
      <input
        type="radio"
        value={isChecked}
        onChange={handleOnChange}
        {...rest}
      />
      {label}
    </label>
  );
};

Radio.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  errormessage: PropTypes.string,
};

Radio.defaultProps = {
  onChange: () => {},
  isChecked: 'off',
  label: [],
  name: '',
  className: '',
  errormessage: '',
  id: '',
};

export default Radio;
